import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

// Public
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import LoanDetail from "@/pages/public/LoanDetail";
import EMICalculator from "@/pages/public/EMICalculator";
import Apply from "@/pages/public/Apply";
import Contact from "@/pages/public/Contact";
import FAQ from "@/pages/public/FAQ";
import Privacy from "@/pages/public/Privacy";
import Terms from "@/pages/public/Terms";
import PublicUploadLink from "@/pages/public/PublicUploadLink";
import PublicDownloadLink from "@/pages/public/PublicDownloadLink";

// Admin
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import Customers from "@/pages/admin/Customers";
import CustomerDetail from "@/pages/admin/CustomerDetail";
import LoanPipeline from "@/pages/admin/LoanPipeline";
import Documents from "@/pages/admin/Documents";
import Insurance from "@/pages/admin/Insurance";
import Followups from "@/pages/admin/Followups";
import Tasks from "@/pages/admin/Tasks";
import Attendance from "@/pages/admin/Attendance";
import Employees from "@/pages/admin/Employees";
import Reports from "@/pages/admin/Reports";
import ExcelIO from "@/pages/admin/ExcelIO";
import Telecaller, { TelecallerLeads, TelecallerLoans, TelecallerInsurance } from "@/pages/admin/Telecaller";
import DocConfig from "@/pages/admin/DocConfig";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<LoanDetail />} />
              <Route path="/emi-calculator" element={<EMICalculator />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Route>

            {/* Public secure upload link */}
            <Route path="/upload/:token" element={<PublicUploadLink />} />
            <Route path="/download/:token" element={<PublicDownloadLink />} />

            {/* Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="telecaller" element={<Telecaller />}>
                <Route index element={<TelecallerLeads />} />
                <Route path="loans" element={<TelecallerLoans />} />
                <Route path="insurance" element={<TelecallerInsurance />} />
              </Route>
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="loans" element={<LoanPipeline />} />
              <Route path="documents" element={<Documents />} />
              <Route path="insurance" element={<Insurance />} />
              <Route path="followups" element={<Followups />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="employees" element={<ProtectedRoute minRole="branch_manager"><Employees /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute minRole="branch_manager"><Reports /></ProtectedRoute>} />
              <Route path="excel" element={<ProtectedRoute minRole="admin"><ExcelIO /></ProtectedRoute>} />
              <Route path="doc-configs" element={<ProtectedRoute minRole="admin"><DocConfig /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
